const styles = {
  container: {
    gap: {
      md: '0',
      sm: '16px',
    },
  },
  item: {
    paddingRight: {
      xs: '24px',
      xl: '40px',
    },
    paddingTop: {
      xs: '16px',
      xl: '0',
    },
    '&:nth-of-type(2n)': {
      paddingRight: {
        xs: 0,
        xl: '40px',
      },
    },
    '&:nth-of-type(1)': {
      paddingTop: {
        xs: '0',
      },
    },
    '&:nth-of-type(2)': {
      paddingTop: {
        xs: '0',
      },
    },
  },
  value: {
    color: 'kit.text.h',
    fontSize: { xs: 42, lg: 60 },
    marginBottom: {
      xs: '4px',
      xl: '8px',
    },
  },
  description: {
    fontSize: 16,
    // whiteSpace: 'pre-wrap',
  },
  itemContainer: (theme) => ({
    maxWidth: '152px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  }),
};

export default styles;
